import PrimeContactProfilePage from "../features/crm/PrimeContactProfilePage";

export default function PrimeContactProfileRoute() {
  return <PrimeContactProfilePage />;
}
